<template functional>
  <div class="text">
    <span
      v-bind:style="
        props.row.color.color_text
          ? `color:${props.row.color.color_text}`
          : `mixBlendMode: 'difference'`
      "
    >
      {{
        props.row.color.color ? props.row.color.color : props.row.color
      }}</span
    >
  </div>
</template>

<script>
export default {
  name: 'ColorFormatter',
};
</script>
